import quizzes from '../requests/quizzes.js'

class Quiz{

   constructor(ctx, slugQuiz, number, callback) {
    this.number = number;
    this.quiz = {};
    var parent = this;
    quizzes.getBySlug(ctx,slugQuiz, function(quiz,err){
      if(quiz){
        // Get les questions.
        quizzes.getQuestions(ctx,slugQuiz, function(questions,err_questions){
          if(questions){
            quiz["questions"] = questions;
            // Get les responses.
            quizzes.getResponses(ctx,slugQuiz, function(responses,err){
              if(responses){
                quiz["responses"] = responses;
                parent.quiz = quiz;
                parent.filters = quiz.groups;
                // console.log("GET QUIZ",quiz);
                callback(null,parent);
              }
              else{
                parent.quiz = quiz;
                console.log("err get responses",err);
                toastr.error("Impossible de récupérer les réponses.","ERREUR");
                callback(true);
              }
            })
          }
          else{
            parent.quiz = quiz;
            console.log("err_questions",err_questions);
            toastr.error("Impossible de récupérer les questions du questionnaire.","ERREUR");
            callback(true);
          }
        })
      }
      else{
        parent.quiz = null;
        console.log("err",err);
        toastr.error("Impossible de récupérer le questionnaire.","ERREUR");
        callback(true);
      }
    })

  }

  nbQuestionsOpenOutMultiple(){
    var nb = 0;
    if(this.quiz && this.quiz.questions){
      for(var i=0;i<this.quiz.questions.length;i++){
        if(this.quiz.questions[i].type == "text"){
          nb++;
        }
      }
    }
    return nb;
  }

  nbQuestionsOpen(){
    var nb = 0;
    if(this.quiz && this.quiz.questions){
      for(var i=0;i<this.quiz.questions.length;i++){
        if(this.quiz.questions[i].type == "text"){
          nb++;
        }
        else if((this.quiz.questions[i].type == "checkbox_multiple" || this.quiz.questions[i].type == "radio_multiple")&& this.quiz.questions[i].data){
          for(var c=0;c<this.quiz.questions[i].data.length;c++){
            if(this.quiz.questions[i].data[c].question && this.quiz.questions[i].data[c].question.type == "text"){
              nb++;
            }
          }
        }
      }
    }
    return nb;
  }

  nbParticipants(){
    var nb = null;
    var infinity = false;
    if(this.quiz && this.quiz.groups){
      nb=0;
      for(var g=0;g<this.quiz.groups.length;g++){
        for(var f=0;f<this.filters.length;f++){
          if(this.filters[f].name == this.quiz.groups[g].name){
            nb += this.quiz.groups[g].nb_participants;
            if(this.quiz.groups[g].nb_participants == 0){
              infinity = true;
            }
          }
        }
      }
    }
    if(infinity){
      if(nb != 0){
        nb = "> "+nb;
      }
      else{
        nb = NaN
      }
    }
    return nb;
  }

  nbResponses(){
    // Retourner le nombre de réponse en fonction du filtre.

    var parent = this;
    var getGroup = function(groupId){
      for(var g=0;g<parent.quiz.groups.length;g++){
        if(parent.quiz.groups[g].id.toString() == groupId.toString()){
          return parent.quiz.groups[g].name;
        }
      }
    }

    var filterParticipants = function(groupId){
      var groupName = getGroup(groupId)
      for(var f=0;f<parent.filters.length;f++){
        if(parent.filters[f].name == groupName){
          return true;
        }
      }
      return false;
    }

    var count = 0;
    for(var r=0;r<this.quiz.responses.length;r++){
      if(filterParticipants(this.quiz.responses[r].groupId) === true){
        count++;
      }
    }
    return count;
  }

  statsGroups(){
    var dataProvider = [];
    for(var g=0;g<this.quiz.groups.length;g++){
      // On regarde le filtre !
      for(var f=0;f<this.filters.length;f++){
        if(this.filters[f].name == this.quiz.groups[g].name){
          var nb_participants = 0;
          for(var g2=0;g2<this.quiz.responses.length;g2++){
            if(this.quiz.responses[g2].groupId && this.quiz.responses[g2].groupId.toString() == this.quiz.groups[g].id.toString()){
              nb_participants++;
            }
          }
          dataProvider.push({groupe:this.quiz.groups[g].name,participants:nb_participants});
        }
      }
    }
    return dataProvider;
  }

  majCategorie(categories,nbResponseTotal,response,groupId){
    var catName = response.noResponse ? "Ne se prononce pas" : response.value;
    for(var c=0;c<categories.length;c++){
      var isPresent = false;
      if(Array.isArray(catName)){
        for(var a=0;a<catName.length;a++){
          if(categories[c].name == catName[a]){
            isPresent = true;
          }
        }
      }
      else if(categories[c].name == catName){
        isPresent = true;
      }
      if(isPresent){
        var nb = nbResponseTotal*categories[c].y/100; // On enlève le pourcentage.
        // console.log("nb",nb)
        nb += 1;
        for(var g=0;g<categories[c].categories_groups.length;g++){
          if((categories[c].categories_groups[g].id && groupId) && categories[c].categories_groups[g].id.toString() == groupId.toString()){
            categories[c].y2 = nb;
            categories[c].y = parseFloat((nb*100/nbResponseTotal)); // On remet le pourcentage.
            categories[c].data_y2[g] = categories[c].data_y2[g]+1;
          }
        }
      }
    }
    return categories;
  }

  statsResponses(oneQuestion){
    var parent = this;
    var calculsStats = function(question,question_index,child_index,statsParent){
      var categories = [];

      // Définir les categories pour chaque questions.
      var data_y = [];
      var data_y2 = []; // y2 = y mais sans pourcentage.
      for(var g=0;g<parent.filters.length;g++){
        data_y.push(0);
        data_y2.push(0);
      }


      var color_no_response = question.color_no_response ? question.color_no_response : "#00b0f0";
      categories.push({name:"Ne se prononce pas", y:0,y2:0,data_y:data_y,data_y2:data_y2,categories_groups:parent.filters,color:color_no_response});
      if(question.type == "scale"){
        // Alors max et min.
        var min = question.min ? parseInt(question.min) : 0;
        var max = question.max ? parseInt(question.max) : 0;
        if(min > max){
          var tmp = min;
          min = max;
          max = tmp;
        }
        var i=min;
        var c=0;
        while(i <= max){
          var data_y_copy = [];
          var data_y2_copy = [];
          data_y_copy = data_y_copy.concat(data_y)
          data_y2_copy = data_y2_copy.concat(data_y2)
          var color = question && question.colors && question.colors[c] ? question.colors[c] : null;
          categories.push({name:i, y:0,y2:0,data_y:data_y_copy,data_y2:data_y2_copy,categories_groups:parent.filters,color:color});
          i++;
          c++;
        }
      }
      else{
        for(var d=0; d<question.data.length;d++){
          var data_y_copy = [];
          var data_y2_copy = [];
          data_y_copy = data_y_copy.concat(data_y)
          data_y2_copy = data_y2_copy.concat(data_y2)
          var color = question && question.data[d] && question.data[d].color ? question.data[d].color : null;
          categories.push({name:question.data[d].name, y:0,y2:0,data_y:data_y_copy,data_y2:data_y2_copy,categories_groups:parent.filters,color:color});
        }
      }

      for(var r=0;r<parent.quiz.responses.length;r++){
        for(var qr=0;qr<parent.quiz.responses[r].questions.length;qr++){
          if(qr == question_index){
            if(child_index != null && parent.quiz.responses[r].questions[qr].data){
              for(var c=0;c<parent.quiz.responses[r].questions[qr].data.length;c++){
                if(c == child_index){
                  // On MAJ uniquement si la question a été remplie.
                  if(parent.quiz.responses[r].questions[qr].data[child_index].value !== "" || parent.quiz.responses[r].questions[qr].data[child_index].noResponse == true){
                    // Envoyer le nombre de personne ayant répondu à la sous question. Correspondant au y réel des statsParent.
                    var y_real = statsParent[child_index] ?  parent.quiz.responses.length*statsParent[child_index].y/100 : 0;  // On enlève le pourcentage.
                    parent.majCategorie(categories,y_real,parent.quiz.responses[r].questions[qr].data[child_index],parent.quiz.responses[r].groupId);
                  }
                }
              }
            }
            else{
              parent.majCategorie(categories,parent.quiz.responses.length,parent.quiz.responses[r].questions[qr],parent.quiz.responses[r].groupId);
            }
          }
        }
      }


      // Calcul du % de chaque groupes par catégorie de réponse.
      for(var cat=0;cat<categories.length;cat++){
        // data_y2 = nb réel de personne ayant répondu. data_y2[0] = nb personne ayant répondu du groupe 0.
        for(var d=0;d<categories[cat].data_y2.length;d++){
          // var y_real = parent.quiz.responses.length*categories[cat].y/100; // On enlève le pourcentage de y. // comparaison par rapport au nb de réponse dans cette catégorie.
          // Il faut comparer par rapport à l'ensemble des réponses. Attention pour les questions enfants il faut comparer par rapport à l'ensemble des réponses de la catégorie de la question parente.
          var y_real = !child_index ? parent.quiz.responses.length : parent.quiz.responses.length*statsParent[child_index].y/100;
          categories[cat].data_y[d] = y_real > 0 ? parseFloat((categories[cat].data_y2[d] * 100 / y_real)) : 0;
        }
      }

      return categories;
    }

    var drawGraph = function(question,stats,child_id){


      var colors = ["#09b259","#fa0909","#fadb09","#97d059","#cc0909"];  // Couleurs clients.
      colors = colors.concat(Highcharts.getOptions().colors); // +10 couleurs par défaut.

      var categories = [];
      var data = [];
      var color_index = 0;
      var hasResponse = false;

      for(var cd=0;cd<stats.length;cd++){
        if(stats[cd].y > 0){
          hasResponse = true;
        }
        categories.push(stats[cd].name);
        var group_name = [];
        for(var gn=0;gn<stats[cd].categories_groups.length;gn++){
          group_name.push(stats[cd].categories_groups[gn].name);
        }


        data.push({
          y:parseFloat(stats[cd].y2.toFixed(1)),
          color:stats[cd].color ? stats[cd].color : colors[color_index],
          drilldown:{
            name: 'Groupes',
            categories:group_name,
            data:stats[cd].data_y2,
            color: colors[color_index]
          }
        })
        color_index++;
        if(color_index > 15){
          color_index = 0; // si + de 15 choix disponibles, alors certains auront la même couleur.
        }
      }

      // categories = ['Très satisfait', 'Satisfait', 'Neutre', 'Peu satisfait', 'Pas satisfait'],
      // data = [
      //   {
      //     y: 20,
      //     color: "#09b259",
      //     drilldown: {
      //         name: 'Groupes',
      //         categories: ['Directeurs', 'Cadres', 'Ouvriers'],
      //         data: [10, 5, 5],
      //         color: "#09b259"
      //     }
      //   },
      //   {
      //       y: 35,
      //       color: "#97d059",
      //       drilldown: {
      //           name: 'Groupes',
      //           categories: ['Directeurs', 'Cadres', 'Ouvriers'],
      //           data: [5, 15, 15],
      //           color: "#97d059"
      //       }
      //   },
      //   {
      //       y: 10,
      //       color: "#fadb09",
      //       drilldown: {
      //           name: 'Groupes',
      //           categories: ['Directeurs', 'Cadres', 'Ouvriers'],
      //           data: [3, 6, 1],
      //           color: "#fadb09"
      //       }
      //   }, {
      //       y: 25,
      //       color: "#fa0909",
      //       drilldown: {
      //           name: 'Groupes',
      //           categories: ['Directeurs', 'Cadres', 'Ouvriers'],
      //           data: [10, 8, 7],
      //           color: "#fa0909"
      //       }
      //   }, {
      //       y: 15,
      //       color: "#cc0909",
      //       drilldown: {
      //           name: 'Groupes',
      //           categories: ['Directeurs', 'Cadres', 'Ouvriers'],
      //           data: [5, 5, 5],
      //           color: "#cc0909"
      //       }
      //   }
      // ],

      var browserData = [],
      versionsData = [],
      i,
      j,
      dataLen = data.length,
      drillDataLen,
      brightness;

      // Build the data arrays
      for (i = 0; i < dataLen; i += 1) {
          // add browser data
          browserData.push({
              name: categories[i],
              y: data[i].y,
              color: data[i].color
          });

          // add version data
          drillDataLen = data[i].drilldown.data.length;
          for (j = 0; j < drillDataLen; j += 1) {
              brightness = 0.2 - (j / drillDataLen) / 5;
              versionsData.push({
                  name: data[i].drilldown.categories[j],
                  y: data[i].drilldown.data[j],
                  color: Highcharts.Color(data[i].color).brighten(brightness).get()
              });
          }
      }

      var id_chart = !child_id ? 'container'+question.id+'-'+parent.number : 'container_child'+child_id+'-'+parent.number;
      if(hasResponse){

        var graphDetail = {};

        if(!question.graphType || question.graphType == "détaillé"){
          graphDetail = {
              name: 'Votants',
              data: versionsData,
              size: '80%',
              innerSize: '60%',
              showInLegend:false,
              dataLabels: {
                  formatter: function () {
                      // display only if larger than 1
                      return this.percentage > 1 ? '<b>' + this.point.name + ':</b> ' +
                          this.percentage.toFixed() + '% ' : null;
                  }
              },
              id: 'versions'
          };
      }

        var legendeBelow = !question.legendeType || question.legendeType == "below" ? true : false;

        $("#"+id_chart).html("");
        Highcharts.setOptions({
          lang: {
            contextButtonTitle: "Chart context menu",
            decimalPoint: ",",
            downloadJPEG: "Télécharger au format JPEG image",
            downloadPDF: "Télécharger au format PDF document",
            downloadPNG: "Télécharger au format PNG image",
            downloadSVG: "Télécharger au format SVG vector image",
            drillUpText: "Retour à {series.name}",
            loading: "Chargement...",
            months: [ "Janvier" , "Février" , "Mars" , "Avril" , "Mai" , "Juin" , "Juillet" , "Août" , "Septembre" , "Octobre" , "Novembre" , "Decembre"],
            noData: "Aucune donnée à afficher",
            printChart: "Imprimer le graphique",
            resetZoom: "Réinitialiser le zoom",
            shortMonths: [ "Jan" , "Feb" , "Mar" , "Avr" , "Mai" , "Jun" , "Jul" , "Aou" , "Sep" , "Oct" , "Nov" , "Dec"],
            weekdays: ["Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"]
          }
        });
        Highcharts.chart(id_chart, {
          credits:{
            enabled: false
          },
          chart: {
              type: 'pie'
          },
          title: {
              text: ''
          },
          subtitle: {
              text: ''
          },
          yAxis: {
              title: {
                  text: 'Total percent market share'
              }
          },
          plotOptions: {
              pie: {
                shadow: false,
                center: ['50%', '50%'],
                showInLegend: true
              }
          },
          legend:{
            labelFormatter: function(){
              return this.name + " ("+this.percentage.toFixed()+"%)";
            }
          },
          tooltip: {
              valueSuffix: '%',
              useHTML:true,
              formatter: function(){
                return this.point.name + "<br><span style='font-size:20px;color:"+this.color+";position:relative;top:3px;'>•</span> " + this.y +"/"+this.total+" (" +this.percentage.toFixed(2)+"%)";
              }
          },
          series: [{
              name: 'Votants',
              data: browserData,
              size: '60%',
              showInLegend:legendeBelow,
              dataLabels: {
                formatter: function () {
                    if(question.graphType != "simple") return null;
                    return this.percentage > 5 ? this.point.name +" : "+this.percentage.toFixed() +"%" : this.y > 1 ? this.percentage.toFixed()+"%": null;
                },
                color: '#000000'
              }
          }, graphDetail],
          responsive: {
              rules: [{
                  condition: {
                      maxWidth: 400
                  },
                  chartOptions: {
                      series: [{
                          id: 'versions',
                          dataLabels: {
                              enabled: false
                          }
                      }]
                  }
              }]
          }
        });
      }
      else{
        $("#"+id_chart).html("Aucune réponse.");
      }

    }

    // Pour chaque question on calcul les stats et on crée le graphique.
    var list_questions = parent.quiz.questions;
    for(var q=0;q<list_questions.length;q++){
      if(list_questions[q].type != "text"){
        if((oneQuestion && (oneQuestion.id == list_questions[q].id)) || !oneQuestion){
          var stats_data = calculsStats(list_questions[q],q);
          drawGraph(list_questions[q],stats_data);
          if(list_questions[q].data){
            for(var d=0;d<list_questions[q].data.length;d++){
              if(list_questions[q].data[d].question && list_questions[q].data[d].question.type != "text"){
                var stats_data_child = calculsStats(list_questions[q].data[d].question,q,d,stats_data);
                drawGraph(list_questions[q].data[d].question,stats_data_child,list_questions[q].data[d].id)
              }
            }
          }
        }
      }
    }

  }

  formatForCsv(txt){
    if(txt){
      return txt.toString().replace(new RegExp(" ; ", 'g'), " , ");
    }
    return "";
  }

  prepareListParticipants(){
    var dataSetParticipants = [];
    var th = [];
    th.push("<span class='tr-green colspan-5'>"+this.formatForCsv(this.quiz.title)+"</span>");
    th.push("");
    th.push("");
    th.push("");
    th.push("");

    dataSetParticipants.push(th);
    for(var a=0;a<this.quiz.responses.length;a++){
      var tr = [];
      tr.push(new Date(this.quiz.responses[a].created).toLocaleDateString()+" à "+new Date(this.quiz.responses[a].created).toLocaleTimeString())
      tr.push(this.formatForCsv(this.quiz.responses[a].lastname));
      tr.push(this.formatForCsv(this.quiz.responses[a].firstname));
      tr.push(new Date(this.quiz.responses[a].birthday).toLocaleDateString())
      var groupName = "";
      for(var g=0;g<this.quiz.groups.length;g++){
          if(this.quiz.groups[g].id.toString() == this.quiz.responses[a].groupId.toString()){
            groupName = this.formatForCsv(this.quiz.groups[g].name);
          }
      }
      tr.push(groupName);

      for(var f=0;f<this.filters.length;f++){
        if(this.filters[f].name == groupName){
          dataSetParticipants.push(tr);
        }
      }

    }

    var columnsParticipants = [];
    columnsParticipants.push({title:"Date de réponse"});
    columnsParticipants.push({title:"Nom"});
    columnsParticipants.push({title:"Prénom"});
    columnsParticipants.push({title:"Date de naissance"});
    columnsParticipants.push({title:"Groupe"});

    return {
      columnsParticipants:columnsParticipants,
      dataSetParticipants:dataSetParticipants
    }

  }

  prepareList(){
    var dataSet = [];
    for(var a=0;a<this.quiz.questions.length;a++){
      if(this.quiz.questions[a].type == "text"){
        var th = [];
        th.push(a+1);
        th.push("<span class='tr-green colspan-2'>"+this.formatForCsv(this.quiz.questions[a].title)+"</span>");
        th.push("");
        dataSet.push(th);
        for(var r=0;r<this.quiz.responses.length;r++){
          var tr = [];
          tr.push((a+1)+"."+(r+1))
          var groupName = "";
          for(var g=0;g<this.quiz.groups.length;g++){
              if(this.quiz.groups[g].id.toString() == this.quiz.responses[r].groupId.toString()){
                groupName = this.formatForCsv(this.quiz.groups[g].name);
              }
          }
          tr.push(groupName);
          tr.push(this.quiz.responses[r].questions[a] && this.quiz.responses[r].questions[a].noResponse ? "Ne se prononce pas" : this.formatForCsv(this.quiz.responses[r].questions[a].value));

          for(var f=0;f<this.filters.length;f++){
            if(this.filters[f].name == groupName){
              dataSet.push(tr);
            }
          }
        }

      }
      else if(this.quiz.questions[a].type == "checkbox_multiple" || this.quiz.questions[a].type == "radio_multiple"){
        if(this.quiz.questions[a].data){
          for(var d=0;d<this.quiz.questions[a].data.length;d++){
            if(this.quiz.questions[a].data[d].question && this.quiz.questions[a].data[d].question.type == "text"){
              var th = [];
              th.push(a+1);
              th.push("<span class='tr-green colspan-2'>"+this.formatForCsv(this.quiz.questions[a].title)+"</span>");
              th.push("");
              dataSet.push(th);
              var th2 = [];
              th2.push((a+1)+'.'+(d+1));
              th2.push("<span class='tr-green-light colspan-2'>"+this.formatForCsv(this.quiz.questions[a].data[d].name) + " : " + this.formatForCsv(this.quiz.questions[a].data[d].question.title)+"</span>");
              th2.push("");
              dataSet.push(th2);
              for(var r=0;r<this.quiz.responses.length;r++){
                var tr = [];
                tr.push((a+1)+"."+(d+1)+"."+(r+1))
                var groupName = "";
                for(var g=0;g<this.quiz.groups.length;g++){
                    if(this.quiz.groups[g].id.toString() == this.quiz.responses[r].groupId.toString()){
                      groupName = this.formatForCsv(this.quiz.groups[g].name);
                    }
                }
                tr.push(groupName);
                if(this.quiz.responses[r] && this.quiz.responses[r].questions[a] && this.quiz.responses[r].questions[a].data && this.quiz.responses[r].questions[a].data[d]){
                  tr.push(this.quiz.responses[r].questions[a].data[d] && this.quiz.responses[r].questions[a].data[d].noResponse ? "Ne se prononce pas" : this.formatForCsv(this.quiz.responses[r].questions[a].data[d].value));
                  for(var f=0;f<this.filters.length;f++){
                    if(this.filters[f].name == groupName){
                      if(this.quiz.responses[r].questions[a].data[d] && this.quiz.responses[r].questions[a].data[d].noResponse || this.quiz.responses[r].questions[a].data[d] && this.quiz.responses[r].questions[a].data[d].value != '')
                      dataSet.push(tr);
                    }
                  }
                }
              }
            }
          }
        }
      }

    }

    var columns = [];
    columns.push({title:"N°"});
    columns.push({title:"Groupe",orderable:false});
    columns.push({title:"Réponse",orderable:false});

    return {
      columns:columns,
      dataSet:dataSet
    }

  }

  getPreconizations(ctx,slug,callback){
    var parent = this;
    quizzes.getPreconizations(ctx,slug,function(preconizations,err){
      if(preconizations){
        parent.preconizations = preconizations;
      }
      else{
        toastr.error("Impossible de récupérer les préconisations du questionnaire.","ERREUR");
      }
      callback(preconizations,err);
    })
  }
}

export { Quiz as default }



// WEBPACK FOOTER //
// ./src/store/quiz.js